import { FileStatusResponse, MobileValidationResponse } from '../../utils/Types';

export interface MobileSingleValidationState {
    loading: boolean;
    success: boolean;
    error: any;
    data: MobileValidationResponse[];
}

export interface MobileBulkValidationState {
    loading: boolean;
    success: boolean;
    error: any;
    data: boolean;
}

export interface ProcessedFilesState {
    loading: boolean;
    success: boolean;
    error: any;
    data: FileStatusResponse[];
}

export interface DownloadProcessedFileState {
    loading: boolean;
    success: boolean;
    error: any;
    data: any;
}

export const mobileSingleValidationInitialState: MobileSingleValidationState = {
    loading: false,
    success: false,
    error: null,
    data: [],
};

export const mobileBulkValidationInitialState: MobileBulkValidationState = {
    loading: false,
    success: false,
    error: null,
    data: false,
};

export const processedFilesInitialState: ProcessedFilesState = {
    loading: false,
    success: false,
    error: null,
    data: [],
};

export const downloadProcessedFileInitialState: DownloadProcessedFileState = {
    loading: false,
    success: false,
    error: null,
    data: null,
};
